import useHotkey, { ESCAPE_HOTKEY } from "./useHotkey";

export default useHotkey;

export { ESCAPE_HOTKEY };
